import $ from 'jquery';
import { Functions } from '../helpers';

export class Forms {

	constructor( App ) {
		// console.log("jquery loaded ?", $ instanceof Function);
		// console.log("jquery.validate loaded?", $().validate instanceof Function);
		Forms.App           = App;
		Forms.UI            = App.PwnUI;
		Forms.settings      = App.settings;
		this.$contactForm   = $( '.js-pwn-contact-form .wpcf7-form' );
		this.$commentForm   = $( '.js-pwn-commentform' );
		this.$wpcf7_element = $( '.wpcf7' );
		this.$wpcf7_form    = $( '.wpcf7 .wpcf7-form' );
		this.initialize();
	};

	initialize() {
	    // this.addMethods();
	    // this.extendDefaults();
	    // this.validation();
	    this.wpCF7();
	};

	addMethods() {
        /**
		 * Impose a custom validation regex for email
		 */
		$.validator.addMethod( 'pwnEmail', function( email, element, param ) {
			email = email.replace( /\s+/g, "" );
			return this.optional( element ) || /^((([a-z]|\d|[!#\$%&'\*\+\-\/=\?\^_`{\|}~]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])+(\.([a-z]|\d|[!#\$%&'\*\+\-\/=\?\^_`{\|}~]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])+)*)|((\x22)((((\x20|\x09)*(\x0d\x0a))?(\x20|\x09)+)?(([\x01-\x08\x0b\x0c\x0e-\x1f\x7f]|\x21|[\x23-\x5b]|[\x5d-\x7e]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(\\([\x01-\x09\x0b\x0c\x0d-\x7f]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]))))*(((\x20|\x09)*(\x0d\x0a))?(\x20|\x09)+)?(\x22)))@((([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])*([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])))\.)+(([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])*([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])))$/i.test( email );
		}, "Adresa dvs. de e-mail trebuie să respecte formatul: nume@domeniu.com." );

        /**
		 * Impose a custom validation regex for phone numbers
		 */
    	$.validator.addMethod( 'pwnPhoneNumber', function( phone_number, element ) {
    	    phone_number = phone_number.replace( /\s+/g, "" );
    	    return this.optional( element ) || phone_number.length > 9 &&
    	    phone_number.match( /^(?:(?:\(?(?:00|\+)([1-4]\d\d|[1-9]\d?)\)?)?[\-\.\\\ \/]?)?((?:\(?\d{1,}\)?[\-\.\\\ \/]?){0,})(?:[\-\.\\\ \/]?(?:#|ext\.?|extension|x)[\-\.\\\ \/]?(\d+))?$/i );
    	}, "Please specify a valid phone number" );

        /**
		 * Impose a custom validation for select element. The user must choose an option
		 * that is inequal with param value
		 */
		$.validator.addMethod( 'pwnSelectMustHaveOptionInequal', function( value, element, param ) {
			return param != value;
		}, "Please choose an option" );
	};

	extendDefaults() {
        /**
		 * Overwrite validator defaults methods of extend them
		 */
		$.extend( $.validator.defaults, {
			errorPlacement: function( error, element ) {
				var form_group = $( element ).closest( '.form-group' );
				var form_group_wrap = $( element ).closest( '.wpcf7-form-control-wrap' );

				if ( form_group.length  ) {
					error.appendTo( form_group );
				}
				else if ( form_group_wrap.length ) {
					error.appendTo( form_group_wrap );
				}
				else {
					error.appendTo( element );
				}
			},
			highlight: function( element, errorClass, validClass ) {
				var is_select_type = $( element ).is( 'select' );
				var form_group = $( element ).closest( '.form-group' );
				var has_custom_select_label = form_group.length && form_group.find( '.custom-select-label' ) ? true : false;

				if ( is_select_type ) {
					$( element ).addClass( errorClass ).removeClass( validClass );

					if ( has_custom_select_label ) {
						$( element ).closest( '.form-group' ).find( '.custom-select-label' ).addClass( errorClass );
					}
				}
				else {
					$( element ).addClass( errorClass ).removeClass( validClass );
				}
			},
			unhighlight: function( element, errorClass, validClass ) {
				var is_select_type = $( element ).is( 'select' );
				var form_group = $( element ).closest( '.form-group' );
				var has_custom_select_label = form_group.length && form_group.find( '.custom-select-label' ) ? true : false;

				if ( is_select_type ) {
					$( element ).removeClass( errorClass ).addClass( validClass );

					if ( has_custom_select_label ) {
						$( element ).closest( '.form-group' ).find( '.custom-select-label' ).removeClass( errorClass );
					}
				}
				else {
					$( element ).removeClass( errorClass ).addClass( validClass );
				}
			}
		} );
	};

	validation() {
		/**
		 * Validate contact form fields
		 */
		if ( this.$contactForm.length ) {
			this.$contactForm.validate( {
				rules: {
				    'your-name': {
				    	required: true
				    },
				    'your-email': {
				        required: true,
				        email: true
				    },
				},
				messages: {
					'your-name': {
						required: "Numele este obligatoriu."
					},
					'your-email': {
						required: "E-mail este obligatoriu.",
						email: "Adresa dvs. de e-mail trebuie sÄƒ respecte formatul: nume@domeniu.com.",
					},
				},
            } );
		}
	};

	wpCF7() {
		if ( ! this.$wpcf7_element.length || ! this.$wpcf7_form.length ) return;

    	this.$wpcf7_element.each( function( index, el ) {
    		$( this ).on( 'wpcf7:mailsent', function() {
    			window.location.hash = '#success';
    		} );

    		$( this ).on( 'wpcf7:mailfailed', function() {
    			window.location.hash = '#failed';
    		} );

    		$( this ).on( 'wpcf7:spam', function() {
    			window.location.hash = '#spam';
    		} );
    	} );
	};
}
